<div>
  <p class="text-right">
    <a
      href="javascript:void(0)"
      (click)="setAllSwitches(!toggleAllValue)"
      role="button"
      data-cy="nspMobileToggleAll"
      >{{ getToggleKey() | translate }}</a
    >
  </p>
</div>
<div class="panel rs-bg-grey2" *ngFor="let accessNumber of getNspSwitchesKeys(); let i = index">
  <div class="rs-flex-row rs-flex-middle">
    <div class="rs-flex-column rs-flex-shrink">
      <p>
        <i class="icon-Smartphone icon-lh rs-txt-purple rs-txt-s7" aria-hidden="true"></i>
      </p>
    </div>
    <div class="rs-flex-column">
      <p id="ac-switch-text0" class="rs-txt-purple rs-font-pxB">
        <mprd-access-number-formatter
          [accessNumber]="accessNumber"
          [plc]="'MV'"
        ></mprd-access-number-formatter>
      </p>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <div class="rs-switch">
        <input
          type="checkbox"
          attr.id="{{ 'switch' + i }}"
          attr.name="{{ 'switch' + i }}"
          role="switch"
          (click)="handleSwitch(accessNumber)"
          [checked]="switchesValues[accessNumber].value"
          data-cy="nspMobileListSwitch"
        />
        <label attr.for="{{ 'switch' + i }}" attr.aria-labelledby="{{ 'ac-switch-text' + i }}">
          <span class="rs-switch-active" aria-hidden="true">{{
            'nsp.activationMobile.switch.yes' | translate
          }}</span>
          <span class="rs-switch-inactive" aria-hidden="true">{{
            'nsp.activationMobile.switch.no' | translate
          }}</span>
        </label>
      </div>
    </div>
  </div>
  <p
    *ngIf="switchesValues[accessNumber].active"
    class="rs-status rs-status-ok"
    data-cy="nspMobileListActive"
  >
    <i class="rs-status-icon" aria-hidden="true"></i>{{ 'nsp.manage.status.active' | translate }}
  </p>
  <p *ngIf="switchesValues[accessNumber].trialOption" data-cy="nspMobileListTrialOption">
    <span class="rs-txt-promo rs-font-pxB">
      {{ 'nsp.manage.trialOption.freeTrial' | translate }}
    </span>
    {{ 'nsp.manage.trialOption.until' | translate }}
    {{ switchesValues[accessNumber].trialOption?.deactivationDate | date: 'dd MMMM yyyy' }}
  </p>
</div>
